export default __webpack_public_path__ + "static/media/03d.1850d138.svg";